import { ref, provide } from 'vue';
import { FavouriteService } from '@/services';

function connectorClickKeycloak() {
  if (document.querySelector('.keycloak-wrapper')) {
    // Keycloak auth.
    document.querySelector('.keycloak-login-wrapper .ans-openid-connect-login-form .button').click();
  } else if (document.querySelector('button.account-panel-opener')) {
    // Drupal auth.
    document.querySelector('button.account-panel-opener').click();
  }
}

export default function favUpdate({
  id, isFavBtnClicked, callbackFavAdded = () => {}, callbackFadDeleted = () => {},
}) {
  const isConnected = ref(false);
  const resApiFav = ref([]);
  provide('isConnected', isConnected);
  provide('resApiFav', resApiFav);

  if (isConnected.value) {
    if (isFavBtnClicked) {
      FavouriteService.deleteFavourit(id);
      callbackFavAdded();
      resApiFav.value.splice(
        resApiFav.value.findIndex((itemFav) => itemFav.key === id),
        1,
      );
    } else {
      FavouriteService.addFavourit(id);
      callbackFadDeleted();
      resApiFav.value.push({ key: id });
    }
  } else {
    connectorClickKeycloak();
  }
}
